<template>
  <div class="about">
    <h2>This is a page where you can find jobs</h2>
    <p>This page was created in November 2021</p>
  </div>
</template>
